export default __webpack_public_path__ + "static/media/gallery_03.aa11730c.jpg";